import { SidebarMenuItem } from "../../Types/Layout.type"; // Make sure SidebarMenuItem is typed correctly
import { getClientApps, getTenantApps } from '../../Services/AppService';

// Define the utility function to fetch tenant apps from localStorage or API
const getTenantAppsFromStorageOrApi = async (): Promise<any[]> => {
    try {
        const storedTenantApps = localStorage.getItem('tenantApps');

        if (storedTenantApps) {
            // Parse and return tenant apps from localStorage
            return JSON.parse(storedTenantApps);
        } else {
            // Fetch from API if not available in localStorage
            const tenantAppsData = await getTenantApps();

            // Store the fetched tenant apps in localStorage for future use
            localStorage.setItem('tenantApps', JSON.stringify(tenantAppsData));

            return tenantAppsData;
        }
    } catch (error) {
        console.error('Error fetching tenant apps:', error);
        return [];
    }
};

// Define the utility function to fetch Client apps from localStorage or API
const getClientAppsFromStorageOrApi = async (): Promise<any[]> => {
    try {
        const storedClientApps = localStorage.getItem('clientApps');

        if (storedClientApps) {
            // Parse and return Client apps from localStorage
            return JSON.parse(storedClientApps);
        } else {
            // Fetch from API if not available in localStorage
            const clientAppsData = await getClientApps();
            // Extract the app.key for client apps
            const clientApps = clientAppsData.map((app: any) => ({
                key: app.app_id, // Assuming app_id is the unique identifier
                app_id: app.app_id,
                client_id: app.client_id,
                name: app.app.name,
                type: app.app.type,
                slug: app.app.slug
            }));
            // Store the fetched Client apps in localStorage for future use
            localStorage.setItem('clientApps', JSON.stringify(clientApps));

            return clientApps;
        }
    } catch (error) {
        console.error('Error fetching client apps:', error);
        return [];
    }
};

// Define a function to generate the menu list
const generateMenuList = async (userType: string): Promise<SidebarMenuItem[]> => {
    const apps = userType === 'client' 
        ? await getClientAppsFromStorageOrApi()
        : await getTenantAppsFromStorageOrApi();

    // Map tenant apps to the required format
    const appsMenuItems = apps.map((app: any) => ({
        title: app.name,
        path: app.type === 'external' ? app.link : `${process.env.PUBLIC_URL}/apps/${app.slug}`,
        // icon: app.icon || "default-icon", // You can adjust this based on your data structure
        type: "link",  // or "external" based on your app data
    }));

    // Create the menu list with the fetched tenant apps
    return [
        {
            items: [
                { path: `${process.env.PUBLIC_URL}/dashboard`, icon: "Home-dashboard", title: "Dashboard", type: "link" },
                // { title: "All Apps", path: `${process.env.PUBLIC_URL}/apps/all`, type: 'link' },
                // { title: "B2B Training", path: "https://b2benergy.trainercentralsite.eu/#/home", type: "external" },
                ...appsMenuItems, // Use the tenant apps
                { path: `${process.env.PUBLIC_URL}/benchmarks`, title: "Benchmarks", type: "link" },
                // { path: `${process.env.PUBLIC_URL}/portfolio`,  title: "Portfolio", type: "link" },
                { path: `${process.env.PUBLIC_URL}/client/portfolio`, title: userType === 'client' ? "Portfolio" : 'Client Portfolio', type: "link" },
                { path: `${process.env.PUBLIC_URL}/meter-reports`, title: 'Meter Report', type: 'link'},
                { 
                    ...(userType === 'tenant' 
                        ? { path: `${process.env.PUBLIC_URL}/group-meter-reports`, title: 'Group Meter Report', type: 'link' }
                        : {}
                    )
                },
                { path: `https://rb.gy/0xq470`, featherIcon: "help-circle", title: 'Wattswhat', type: 'external'}
            ],
        },
    ];
};

export const menuListPromise = generateMenuList;
